import { createStore } from 'vuex';

import account from '@/store/modules/account';
import breadcrumbs from '@/store/modules/breadcrumbs';

export default createStore({
  modules: {
    account,
    breadcrumbs,
  },
});
